import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title id="Sort">{props.title || 'Sort'}</title>
      <g>
        <path stroke="#449FDB" d="M10.4 10.4" />
        <path d="M19.8 401.8c1.5-3.7 4.2-5.5 8.2-5.5h52.6v-377.1c0-2.6.8-4.7 2.5-6.3 1.6-1.6 3.7-2.5 6.3-2.5h52.6c2.6 0 4.7.8 6.3 2.5 1.6 1.6 2.5 3.7 2.5 6.3v377.1h52.6c2.6 0 4.7.8 6.3 2.5 1.6 1.6 2.5 3.7 2.5 6.3 0 2.2-.9 4.4-2.7 6.6l-87.5 87.4c-1.8 1.6-3.9 2.5-6.3 2.5-2.2 0-4.3-.8-6.3-2.5l-87.7-87.7c-2.7-2.9-3.4-6.1-1.9-9.6zm236.2 38.4c0-2.6.8-4.7 2.5-6.3 1.6-1.6 3.7-2.5 6.3-2.5h70.2c2.6 0 4.7.8 6.3 2.5 1.6 1.6 2.5 3.7 2.5 6.3v52.6c0 2.6-.8 4.7-2.5 6.3-1.6 1.6-3.7 2.5-6.3 2.5h-70.2c-2.6 0-4.7-.8-6.3-2.5-1.6-1.6-2.5-3.7-2.5-6.3v-52.6zm0-87.7v-52.6c0-2.6.8-4.7 2.5-6.3 1.6-1.6 3.7-2.5 6.3-2.5h122.8c2.6 0 4.7.8 6.3 2.5 1.6 1.6 2.5 3.7 2.5 6.3v52.6c0 2.6-.8 4.7-2.5 6.3s-3.7 2.5-6.3 2.5h-122.8c-2.6 0-4.7-.8-6.3-2.5-1.7-1.7-2.5-3.8-2.5-6.3zm0-140.3v-52.6c0-2.6.8-4.7 2.5-6.3 1.6-1.6 3.7-2.5 6.3-2.5h175.4c2.6 0 4.7.8 6.3 2.5 1.6 1.6 2.5 3.7 2.5 6.3v52.6c0 2.6-.8 4.7-2.5 6.3-1.6 1.6-3.7 2.5-6.3 2.5h-175.4c-2.6 0-4.7-.8-6.3-2.5-1.7-1.7-2.5-3.8-2.5-6.3zm0-140.4v-52.6c0-2.6.8-4.7 2.5-6.3 1.6-1.6 3.7-2.5 6.3-2.5h228c2.6 0 4.7.8 6.3 2.5 1.6 1.6 2.5 3.7 2.5 6.3v52.6c0 2.6-.8 4.7-2.5 6.3s-3.7 2.5-6.3 2.5h-228c-2.6 0-4.7-.8-6.3-2.5s-2.5-3.7-2.5-6.3z" />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/sort.js